import './Loading.css'
import { useLocale } from "../../common/locale/LocaleProvider";

export default function Loading() {

  const { locale } = useLocale();
  const { strings } = locale;

  return <div className='loading'><span className="loader"></span>{strings.LOADING}</div>
}